// extracted by mini-css-extract-plugin
export var divider = "_p5-0";
export var systemMessage = "_p5-1";
export var systemMessageWrapper = "_p5-2";